import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c083a9c2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c083a9c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c083a9c2')) {
      api.createRecord('c083a9c2', component.options)
    } else {
      api.reload('c083a9c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c083a9c2&scoped=true&", function () {
      api.rerender('c083a9c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommend/activity/index.vue"
export default component.exports